import React, { useRef, useEffect, useState, useMemo } from 'react'
import { slice, map, prop, isEmpty, sum } from 'ramda'
import { useSelector, useDispatch } from 'react-redux'

import * as medias from 'consts/medias'
import { colors } from 'theme'
import { groupWithCustomer } from 'services/utils'
import {
  getOrdersRequest,
  getOrdersSuccess,
} from 'store/modules/users/ordersForCollect/reducer'
import {
  createCollectRequest,
  updateSelectedWeight,
} from 'store/modules/users/collections/reducer'

import { useMediaQuery } from '@material-ui/core'
import { Content, CollectStatus } from 'components'
import { LoaderArea } from './styles'

import ScaleLoader from 'react-spinners/ScaleLoader'
import InfiniteScroll from 'react-infinite-scroll-component'
import TableCustomerOrders from 'components/Transportadora/TableOrder'
import Filter from './Filter'

// --------------- 𝕄𝕖𝕥𝕒𝕕𝕒𝕥𝕒 ---------------

const LIMITER = 300

// --------------- ℍ𝕖𝕝𝕡𝕖𝕣𝕤 ---------------

const sumWeight = (list) => sum(map(prop('peso_bru_disp'), list))

const getSelectedItems = (tables) => {
  let selectedItems = []

  tables.forEach((table) => {
    selectedItems.push(table.getSelectedItems())
  })

  return selectedItems.flat()
}

const removeTablesSelection = (tables) =>
  tables.forEach((table) => table.selectAll(false))

// --------------- 𝕄𝕒𝕚𝕟 ---------------

export default function OrdersPage() {
  const sm = useMediaQuery(medias.sm)
  const dispatch = useDispatch()

  const tablesRef = useRef([])
  const [tableLimiter, setTableLimiter] = useState(LIMITER)

  const orders = useSelector(
    (state) => state.users.ordersForCollect.filteredOrders
  )
  const selectedFilters = useSelector(
    (state) => state.users.ordersForCollect.selectedFilters
  )

  const loading = useSelector((state) => state.users.ordersForCollect.loading)

  const records = useMemo(
    () => groupWithCustomer([...orders], 'cli_nome'),
    [orders]
  )

  const handlePrint = () => {
    setTableLimiter(records.length)
    setTimeout(() => {
      window.print()
    }, 0)
  }

  const handleAddItemsInCollect = () => {
    const selectedItems = getSelectedItems(tablesRef.current)

    const collects = selectedItems.map((item) => {
      const ownerOrder = orders.find(
        (order) =>
          String([order.cod_pedido, order.id_cia]) ===
          String([item.cod_pedido, item.id_cia])
      )

      return {
        cod_pedido: item.cod_pedido,
        id_cia: item.id_cia,
        id_itens: item.id_itens,
        id_coleta: item.id_coleta,
        cod_produto: item.cod_produto,
        dsc_abreviado: item.dsc_abreviado,
        itped_lote: item.itped_lote,
        id_un_medidas: item.id_un_medidas,
        ped_seupedido: item.ped_seupedido,

        ped_data_emissao: ownerOrder.ped_data_emissao,
        cod_representante: ownerOrder.cod_representante,
        cod_transportadora: ownerOrder.cod_transportadora,
        rep_nome: ownerOrder.rep_nome,
        cod_cliente: ownerOrder.cod_cliente,
        cli_cgc_cpf: ownerOrder.cli_cgc_cpf,
        cliente_nome: ownerOrder.cliente_nome,
        endereco_cliente: ownerOrder.endereco_cliente,
        bairro_cliente: ownerOrder.bairro_cliente,
        cidade_cliente: ownerOrder.cidade_cliente,
        dsc_uf: ownerOrder.dsc_uf,

        vpt_qtd: item.qtd_saldo_disp,
        vpt_peso_bruto: item.peso_bru_disp,
        vpt_pallet: item.qtd_pallet_disp,
        vpt_qtd_caixas: item.qtd_caixas_disp,
        vpt_prd_m2_caixa: item.qtd_m2_caixa,
        vpt_cx_pallet: item.qtd_cx_pallet,

        amostra: item.amostra,
      }
    })

    dispatch(createCollectRequest(collects))
  }

  const handleUpdateWeight = (updatedItens) => {
    const added = sumWeight(updatedItens.filter((item) => item.selected))
    const removed = sumWeight(updatedItens.filter((item) => !item.selected))

    dispatch(
      updateSelectedWeight({
        added,
        removed,
      })
    )
  }

  const fetchMoreData = () => {
    setTimeout(() => {
      setTableLimiter((limiter) => limiter + LIMITER)
    }, 200)
  }

  const calculateCurrentRecords = () =>
    records.length < LIMITER ? records : slice(0, tableLimiter, records)

  const currentRecords = calculateCurrentRecords()

  useEffect(() => {
    dispatch(getOrdersRequest())

    return () => {
      dispatch(getOrdersSuccess({ orders: [] }))
    }
  }, [dispatch])

  useEffect(() => {
    // effect responsible for resetting the states that depend on the requests, after their eventual filtering
    removeTablesSelection(tablesRef.current)

    setTableLimiter(LIMITER)

    dispatch(updateSelectedWeight())
  }, [dispatch, orders])

  return (
    <Content
      title={sm ? 'Pedidos' : null}
      containerId="carrier-orders-container"
      loading={loading}
      sideBarStart={!isEmpty(selectedFilters)}
      SideComponent={<Filter selectedFilters={selectedFilters} />}
      HeaderComponent={
        <CollectStatus
          onPrint={handlePrint}
          onClick={handleAddItemsInCollect}
        />
      }
    >
      <InfiniteScroll
        dataLength={currentRecords.length}
        hasMore={!loading && currentRecords.length < records.length}
        next={fetchMoreData}
        scrollableTarget="carrier-orders-container"
        className="printable"
        scrollThreshold={1}
        loader={
          <LoaderArea>
            <ScaleLoader color={colors.color500} />
            <small>Carregando mais pedidos...</small>
          </LoaderArea>
        }
      >
        {currentRecords.map((data, index) => (
          <TableCustomerOrders
            key={index}
            data={[...data]}
            onUpdate={handleUpdateWeight}
            getRef={(table) => (tablesRef.current[index] = table)}
          />
        ))}
      </InfiniteScroll>
    </Content>
  )
}
